import { useLocation } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import { stripLangPrefix } from '@/utils/localizedPath'

export interface LayoutProps {
  children: React.ReactNode
  onNavigateToAccount?: () => void
  onNavigateToCart?: () => void
}

export default function Layout({ children, onNavigateToAccount, onNavigateToCart }: LayoutProps) {
  const location = useLocation()

  const pathname = stripLangPrefix(location.pathname)
  const isAccountPage = pathname.startsWith('/account')
  const isCheckoutPage = pathname.startsWith('/cart') || pathname.startsWith('/checkout')

  return (
    <div className="w-dvw h-dvh overflow-y-auto flex flex-col font-sans bg-background text-foreground">
      <Header
        onNavigateToAccount={onNavigateToAccount}
        onNavigateToCart={onNavigateToCart}
      />
      <main className={`w-full flex-1 flex flex-col ${isAccountPage || isCheckoutPage ? '' : 'items-center p-5 md:p-8'}`}>
        {children}
      </main>
      <Footer />
    </div>
  )
}
